import { InsightsQueryModel } from './insights-query.model';

export class QueryDefRequest {
  public queryDef: InsightsQueryModel;

  constructor(insightQueryModel: InsightsQueryModel) {
    this.queryDef = insightQueryModel;
  }
}
